//hooks
import { useState } from 'react';

//component
import Home from '../page/Home/Home';
import About from '../page/About/About';
import RoomPage from '../page/Rooms/RoomPage';
import AmenitiesPage from '../page/Amenities/AmenitiesPage';
import GalleryPage from '../page/Gallery/GalleryPage';
import Contact from '../page/Contact/Contact';
import NotFound from '../page/NotFound/NotFound';

//react router dom
import {Routes,Route, Outlet} from 'react-router-dom';

    const LayoutWithMargin = () => {
      return (
        <div>
          <Outlet />
        </div>
      );
    };
function AppRoutes() {
    let [bookingRequest, setBookingRequest] = useState<{cardId: number | null; open: boolean, type: string}>({
      open: false,
      cardId: null,
      type: ""
    });
    // LayoutWithMargin.js
  return (
    <Routes>
        <Route path="/" element={<Home bookingRequest={bookingRequest} setBookingRequest={setBookingRequest} />} />
        <Route element={<LayoutWithMargin />}>
            <Route path="/about" element={<About />} />
            <Route path="/rooms" element={<RoomPage bookingRequest={bookingRequest} setBookingRequest={setBookingRequest} />} />
            <Route path="/amenities" element={<AmenitiesPage bookingRequest={bookingRequest} setBookingRequest={setBookingRequest} />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
        </Route>
    </Routes>
  );
}


export default AppRoutes;
